module.exports = __webpack_public_path__ + "static/media/legacy-1.c2e399dd.jpg";